import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { clearHandoff } from "../lib/handoff";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser((u) => (u === null ? false : u)));
  }, []);

  const authenticate = useCallback(async (mode, payload) => {
    const { data } = await api.post(`/auth/${mode}`, payload);
    setUser(data.user);
  }, []);

  const redeemSso = useCallback(async (ticket) => {
    const { data } = await api.post("/auth/sso/redeem", { ticket });
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    clearHandoff();
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, authenticate, redeemSso, logout }), [user, authenticate, redeemSso, logout]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
